module.exports = __webpack_public_path__ + "static/media/pay.24bd522a.svg";